module.exports = __webpack_public_path__ + "static/media/mastercard2.61d1e827.png";